export const executeCaptcha = async (captchaRef: React.MutableRefObject<any>) => {
  try {
    captchaRef.current.resetCaptcha();
    const { response: captchaToken } = await captchaRef.current.execute({
      async: true,
    });
    return captchaToken;
  } catch (error) {
    console.error('Error processing you request:', error);
  }
};
